import axios from "axios";

export class DashboardService {
  async getSuperAdminMetrics(): Promise<any> {
    return await axios.get(`api/superadmin/metrics`);
  }
  async getSpaceMetrics(spaceId: number): Promise<any> {
    return await axios.get(`/api/spaces/${spaceId}/metrics`);
  }
  async getSuperSpaceMetrics(superSpaceId: number): Promise<any> {
    return await axios.get(`/api/super_spaces/${superSpaceId}/metrics`);
  }
}
